import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface LastLoggedSectionProps {
  patientData: any;
}

const LastLogged: React.FC<LastLoggedSectionProps> = ({ patientData }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogs = () => {
    navigate("/patient-progress", {
      state: { ...patientData, fromPath: location.pathname },
    });
  };

  return (
    <section className="flex overflow-hidden flex-col p-4 mt-4 w-full bg-white rounded-3xl shadow-[0px_1px_16px_rgba(0,0,0,0.05)]">
      <button
        onClick={handleLogs}
        className="overflow-hidden gap-2 self-stretch px-4 py-4 w-full text-lg font-medium leading-none text-center text-white bg-indigo-600 rounded-2xl min-h-[56px]"
      >
        View all logs
      </button>
    </section>
  );
};

export default LastLogged;
